module.exports = __webpack_public_path__ + "static/media/wn_180.9466b2f6.svg";